var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer2RightMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 120,
    viewBox: "0 0 98 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 120,
    transform: "matrix(-1 0 0 1 98 0)",
    fill: "url(#paint0_linear_3117_18637)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3117_18637",
    x1: 98,
    y1: 60,
    x2: 0,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466346,
    stopColor: "#F4EEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4EEFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2RightMobile);
export default __webpack_public_path__ + "static/media/layer2-right-mobile.c0d9f888d7a6c3dffb5398251a08915a.svg";
export { ForwardRef as ReactComponent };